import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('invoices', { params }))
  },

  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('invoice?in_id=' + data.in_id))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('invoice', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('invoice', data, options))
  },

  async updateStatus (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('invoice/status', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('invoice', { data: data }, options))
  },

  async getLatestCode (data) {
    return store.dispatch('checkResponseApi', await Api().get('invoice/latest_code'))
  },
}



// WEBPACK FOOTER //
// ./src/api/InvoiceService.js